<style src="css/reply.css" scoped>
</style>
<style>
.chat-photo {
  position: fixed;
  left: -9999px;
}
</style>
<template>
  <div>
    <!--<topbar :text="mipBaiduQuestion.encryptPhone"></topbar>-->
    <div class="fixedBox">
      <div class="topBox">
        <div class="backIcon" @click="back"></div>
        <!--                <div class="topTitle">{{chatDoctor.doctorName}}</div>-->
        <div class="topTitle">{{ infoData.userName }}</div>
        <div class="rule" @click="to(`userDetails?bespeakId=${bespeakId}`)">详情</div>
      </div>
    </div>
    <div class="chatBox">
      <!--<div class="tipBox">-->
      <!--<div class="tip">您咨询了XXX咨询师，给您提供10次免费回复机会，用完需付费咨询，请注意查收~<span class="red">(在咨询过程中请勿退出该界面)</span></div>-->
      <!--<div class="tip">咨询师已领取您的问题，您可通过下方卡片了解咨询师</div>-->
      <!--</div>-->
      <!--            <div class="docBox">-->
      <!--                <img :src="EnvUrl+chatDoctor.doctorWorkPhoto" alt="">-->
      <!--                <div class="docInfoBox">-->
      <!--                    <div class="docName">{{chatDoctor.doctorName}} <div class="logo">我们</div></div>-->
      <!--                    <div class="docLevel">{{chatDoctor.doctorHospitalLevel}}</div>-->
      <!--                    <div class="docJy">掌上图文咨询，咨询内容严格保密</div>-->
      <!--                </div>-->
      <!--            </div>-->
      <ul class="contentBox" id="box" :class="{active:boxStatus||emojiStatus,active2:moreStatus}">
        <!--                <li style="margin-bottom: .28rem">-->
        <!--                    <div class="chatLeft">-->
        <!--                        <div class="tx">-->
        <!--                            <div class="jtLeft"></div>-->
        <!--                        </div>-->
        <!--                        <span style="margin-top: .2rem;max-width: 4.63rem;padding: .17rem;background: #fff;border-radius: .15rem">您好，请详细描述您的问题，便于我更好的为您咨询</span>-->
        <!--                    </div>-->
        <!--                </li>-->
        <!--                <li style="margin-bottom: .28rem" v-if="chatQuestion">-->
        <!--                    <div style="text-align: center;margin-bottom: .15rem">-->
        <!--                        {{chatQuestion.createTime | time}}-->
        <!--                    </div>-->
        <!--                    <div class="chatRight">-->
        <!--                        <span style="margin-top: .2rem;max-width: 4.63rem;padding: .17rem;background: #6EE8A5;border-radius: .15rem">{{chatQuestion.content}}</span>-->
        <!--                        <div class="zj" :style="{background: `url(${EnvUrl}${infoData.doctorPhoto}) no-repeat center/cover`}">-->
        <!--                            <div class="jtRight"></div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </li>-->
        <li v-for="(item,index) in list" style="margin-bottom: .28rem">
          <div style="text-align: center;margin-bottom: .15rem" v-if="(index+1)%4==1||index==list.length-1">
            {{ item.createTime | time }}
          </div>
          <div :class="{chatLeft:item.chatType==0,chatRight:item.chatType==1}" id="item">
            <!--{{item.chatType==0?'用户：':'医生：'}}-->
            <div class="tx" v-if="item.chatType!=1">
              <div class="jtLeft"></div>
            </div>
            <!--<template v-if="item.contentType==1">-->
            <!--<img v-if="item.contentType==1" :src="item.content" alt="" @click="clickImg($event)"-->
            <!--style="width: 3rem;height: 3rem;object-fit: cover;margin-top: .2rem">-->
            <img防止转换 v-if="item.contentType==1" :src="item.content" preview preview-text=""
                         style="width: 3rem;height: 3rem;object-fit: cover;margin-top: .2rem"/>
            <img防止转换 v-if="item.contentType==4" :src="item.content[1]" preview preview-text=""
                         style="width: 3rem;height: 3rem;object-fit: cover;margin-top: .2rem"/>
            <!--<big-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></big-img>-->
            <!--</template>-->
            <!--<template v-else-if="item.contentType==2">-->
            <div v-if="item.contentType==2" style="margin-top: .2rem">
              <img @click="muiscPlay(item.content)" v-if="item.chatType==0" src="~assets/audioLeft.png"
                   alt="" style="width: 1.91rem;height: .59rem">
              <img @click="muiscPlay(item.content)" v-else="item.chatType==1" src="~assets/audioRight.png"
                   alt="" style="width: 1.91rem;height: .59rem">

            </div>
            <!--</template>-->
            <!--<template v-else>-->

            <span v-if="(item.contentType==0||item.contentType==3)&&item.chatType==1"
                  style="word-break: break-word;margin-top: .2rem;max-width: 4.63rem;padding: .17rem;background: #6EE8A5;border-radius: .15rem"
                  v-html="isUrl(item.content)"></span>


            <span v-if="(item.contentType==0||item.contentType==3)&&item.chatType!=1"
                  style="word-break: break-word;margin-top: .2rem;max-width: 4.63rem;padding: .17rem;background: #fff;border-radius: .15rem"
                  v-html="isUrl(item.content)"></span>

            <div class="zj" v-if="item.chatType==1&&mipDoctor"
                 :style="{background: `url(${EnvUrl}${infoData.doctorPhoto}) no-repeat center/cover`}">
              <div class="jtRight"></div>
            </div>
          </div>


          <!--</template>-->
        </li>
        <!--<div class="tipBox" v-if="chatQuestion&&chatQuestion.times===0">-->
        <!--<div class="tip">由于达到对话次数上限，本次咨询已结束，您可<span class="blue" @click="to(`evaluate?doctorId=${chatDoctor.doctorId}&questionId=${chatQuestion.questionId}`)">立即评价</span>本次咨询~</div>-->
        <!--</div>-->
        <!--<li v-else="" class="chatRight">医生：{{item.content}}</li>-->
      </ul>

      <div class="fixed">
        <!--                <div class="surplus" v-if="chatQuestion">追问中，剩余{{chatQuestion.times}}次回复</div>-->

        <div class="inputBox" v-if="showInput">
          <!--<div class="icon" @click="showBox" v-show="!boxStatus"></div>-->
          <!--<div class="icon2" @click="boxStatus=false" v-show="boxStatus"></div>-->
          <div contenteditable="true" @focus="getFocus()" @input="changeInput()" v-model="content" id="sendInput"
               v-if="replyStatus"
               @blur="changeUnrealHits()"></div>

          <div contenteditable="false" v-model="content" style="background: #eee" id="sendInput" v-else>
            {{ noReplyReason }}
          </div>
          <div class="emojiIcon" @click="showEmoji" v-show="!emojiStatus"></div>
          <div class="emojiIcon2" @click="emojiStatus=false" v-show="emojiStatus"></div>
          <div class="more" v-if="!content" @click="showMore"></div>
          <div class="button" @click="submit" v-if="content">
            发送
          </div>
          <!--<div class="button" v-else>-->
          <!--发送-->
          <!--</div>-->
          <!--<div class="functionBox">-->
          <!--<div class="icon" @click="showBox" v-show="!boxStatus"></div>-->
          <!--<div class="icon2" @click="boxStatus=false" v-show="boxStatus"></div>-->
          <!--</div>-->
        </div>
        <div class="toPayBox" v-if="chatQuestion&&chatQuestion.times===0">
          <div class="toPayBtn"
               @click="to(`payServer?doctorId=${chatDoctor.doctorId}&questionId=${chatQuestion.questionId}`)">购买回复机会
          </div>
        </div>
        <ul class="wordBox" v-show="boxStatus">
          <li v-for="item in baiduCommonPhraseList" @click="toWord(item.phraseContent)">
            {{ item.phraseContent }}
          </li>
          <!--<li>+新增常用语</li>-->
          <!--<li>+新增常用语</li>-->
        </ul>
        <ul class="emojiBox" v-show="emojiStatus">
          <ul>
            <li v-for="item in emojiList" @click="emojiSected(item.char)">{{
                item.char
              }}
            </li>
          </ul>
          <!--<li>+新增常用语</li>-->
          <!--<li>+新增常用语</li>-->
        </ul>
        <ul class="moreBox" v-if="moreStatus">
          <li v-if="bespeakSwitch.photo" @click="openPhoto()">
            <input
              type="file"
              name="file"
              class="chat-photo"
              @change="selectFileEvent(fileNameList)"
              ref="file"
            />
            <div class="moreItem mi1"></div>
            <div class="moreItemName">相册</div>
          </li>
          <li v-if="bespeakSwitch.voice" @click="openMask(0)">
            <div class="moreItem mi2"></div>
            <div class="moreItemName">语音</div>
          </li>
          <li v-if="bespeakSwitch.video" @click="openMask(1)">
            <div class="moreItem mi3"></div>
            <div class="moreItemName">视频</div>
          </li>
          <li v-if="bespeakSwitch.phone" @click="openMask(2)">
            <div class="moreItem mi4"></div>
            <div class="moreItemName">电话</div>
          </li>
          <!--                    <li v-if="bespeakSwitch.shake">-->
          <!--                        <div class="moreItem mi5"></div>-->
          <!--                        <div class="moreItemName">抖一抖</div>-->
          <!--                    </li>-->
          <!--                    <li v-if="bespeakSwitch.reminder">-->
          <!--                        <div class="moreItem mi6"></div>-->
          <!--                        <div class="moreItemName">催单</div>-->
          <!--                    </li>-->
          <!--          <li v-if="bespeakSwitch.notes">-->
          <!--            <div class="moreItem mi7"></div>-->
          <!--            <div class="moreItemName">笔记</div>-->
          <!--          </li>-->
        </ul>
      </div>

    </div>
    <div class="tipBox" v-if="tipStatus">
      <div class="tip">{{ tip }}</div>
    </div>
    <div class="maskBox" v-if="maskStatus">
      <div class="mask">
        <div class="maskTop">
          <div class="maskTitle" style="margin-bottom: 0" v-html="startContent"></div>
        </div>
        <div class="btnBox">
          <div class="btn" @click="cancle">取消</div>
          <div class="btn active" @click="sureStart()">立即发起</div>
        </div>
      </div>
    </div>
    <!--<div class="maskBox" v-if="ruleStatus">-->
    <!--<div class="functionTop">-->
    <!--功能专区-->
    <!--<span @click="ruleStatus=false"></span>-->
    <!--</div>-->
    <!--<ul class="functionListBox">-->
    <!--<li @click="closeNews">-->
    <!--<span></span>-->
    <!--忽略-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--<div class="answer" @click="answer">{{answered}}</div>-->
    <!--<div class="promptBox" v-if="prompt">-->
    <!--<div class="prompt">-->
    <!--{{hint}}-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>
<script>
import {getSources} from "../api"
import topbar from 'components/topbar'
import bigImg from 'components/big-img'
import Vue from "vue"
import moment from 'moment/moment'
import * as qiniu from 'qiniu-js'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import noMoreData from 'components/no-more-data'

Vue.use(preview)
//    import {timeFormat} from 'utils'
//    Vue.filter('timeFormat', timeFormat)

export default {
  data() {
    return {
      intv: null,
      maskStatus: false,
      connType: '',
      startContent: '',
      tipStatus: false,
      tip: '',
      ruleStatus: false,
      showInput: true,
      emojiList: {
        "grinning": {
          "keywords": ["face", "smile", "happy", "joy", ":D", "grin"],
          "char": "😀",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "grin": {
          "keywords": ["face", "happy", "smile", "joy", "kawaii"],
          "char": "😁",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "smiley": {
          "keywords": ["face", "happy", "joy", "haha", ":D", ":)", "smile", "funny"],
          "char": "😃",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "smile": {
          "keywords": ["face", "happy", "joy", "funny", "haha", "laugh", "like", ":D", ":)"],
          "char": "😄",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "sweat_smile": {
          "keywords": ["face", "hot", "happy", "laugh", "sweat", "smile", "relief"],
          "char": "😅",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "laughing": {
          "keywords": ["happy", "joy", "lol", "satisfied", "haha", "face", "glad", "XD", "laugh"],
          "char": "😆",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "innocent": {
          "keywords": ["face", "angel", "heaven", "halo"],
          "char": "😇",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "wink": {
          "keywords": ["face", "happy", "mischievous", "secret", ";)", "smile", "eye"],
          "char": "😉",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "blush": {
          "keywords": ["face", "smile", "happy", "flushed", "crush", "embarrassed", "shy", "joy"],
          "char": "😊",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "slightly_smiling_face": {
          "keywords": ["face", "smile"],
          "char": "🙂",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "yum": {
          "keywords": ["happy", "joy", "tongue", "smile", "face", "silly", "yummy", "nom", "delicious", "savouring"],
          "char": "😋",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "heart_eyes": {
          "keywords": ["face", "love", "like", "affection", "valentines", "infatuation", "crush", "heart"],
          "char": "😍",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "kissing_heart": {
          "keywords": ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"],
          "char": "😘",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "kissing": {
          "keywords": ["love", "like", "face", "3", "valentines", "infatuation", "kiss"],
          "char": "😗",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "kissing_smiling_eyes": {
          "keywords": ["face", "affection", "valentines", "infatuation", "kiss"],
          "char": "😙",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "kissing_closed_eyes": {
          "keywords": ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"],
          "char": "😚",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "stuck_out_tongue_winking_eye": {
          "keywords": ["face", "prank", "childish", "playful", "mischievous", "smile", "wink", "tongue"],
          "char": "😜",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "stuck_out_tongue_closed_eyes": {
          "keywords": ["face", "prank", "playful", "mischievous", "smile", "tongue"],
          "char": "😝",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "stuck_out_tongue": {
          "keywords": ["face", "prank", "childish", "playful", "mischievous", "smile", "tongue"],
          "char": "😛",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "sunglasses": {
          "keywords": ["face", "cool", "smile", "summer", "beach", "sunglass"],
          "char": "😎",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "roll_eyes": {
          "keywords": ["face", "eyeroll", "frustrated"],
          "char": "🙄",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "flushed": {
          "keywords": ["face", "blush", "shy", "flattered"],
          "char": "😳",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "rage": {
          "keywords": ["angry", "mad", "hate", "despise"],
          "char": "😡",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "confused": {
          "keywords": ["face", "indifference", "huh", "weird", "hmmm", ":/"],
          "char": "😕",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "tired_face": {
          "keywords": ["sick", "whine", "upset", "frustrated"],
          "char": "😫",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "triumph": {
          "keywords": ["face", "gas", "phew", "proud", "pride"],
          "char": "😤",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "fearful": {
          "keywords": ["face", "scared", "terrified", "nervous", "oops", "huh"],
          "char": "😨",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "disappointed_relieved": {
          "keywords": ["face", "phew", "sweat", "nervous"],
          "char": "😥",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "sleepy": {
          "keywords": ["face", "tired", "rest", "nap"],
          "char": "😪",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "sweat": {
          "keywords": ["face", "hot", "sad", "tired", "exercise"],
          "char": "😓",
          "fitzpatrick_scale": false,
          "category": "people"
        },

        "dizzy_face": {
          "keywords": ["spent", "unconscious", "xox", "dizzy"],
          "char": "😵",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "astonished": {
          "keywords": ["face", "xox", "surprised", "poisoned"],
          "char": "😲",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "sneezing_face": {
          "keywords": ["face", "gesundheit", "sneeze", "sick", "allergy"],
          "char": "🤧",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "mask": {
          "keywords": ["face", "sick", "ill", "disease"],
          "char": "😷",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "face_with_thermometer": {
          "keywords": ["sick", "temperature", "thermometer", "cold", "fever"],
          "char": "🤒",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "face_with_head_bandage": {
          "keywords": ["injured", "clumsy", "bandage", "hurt"],
          "char": "🤕",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "sleeping": {
          "keywords": ["face", "tired", "sleepy", "night", "zzz"],
          "char": "😴",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "zzz": {
          "keywords": ["sleepy", "tired", "dream"],
          "char": "💤",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "clap": {
          "keywords": ["hands", "praise", "applause", "congrats", "yay"],
          "char": "👏",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "call_me_hand": {
          "keywords": ["hands", "gesture"],
          "char": "🤙",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "+1": {
          "keywords": ["thumbsup", "yes", "awesome", "good", "agree", "accept", "cool", "hand", "like"],
          "char": "👍",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "-1": {
          "keywords": ["thumbsdown", "no", "dislike", "hand"],
          "char": "👎",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "facepunch": {
          "keywords": ["angry", "violence", "fist", "hit", "attack", "hand"],
          "char": "👊",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "fist": {
          "keywords": ["fingers", "hand", "grasp"],
          "char": "✊",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "v": {
          "keywords": ["fingers", "ohyeah", "hand", "peace", "victory", "two"],
          "char": "✌",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "ok_hand": {
          "keywords": ["fingers", "limbs", "perfect", "ok", "okay"],
          "char": "👌",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "raised_hand": {
          "keywords": ["fingers", "stop", "highfive", "palm", "ban"],
          "char": "✋",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "raised_back_of_hand": {
          "keywords": ["fingers", "raised", "backhand"],
          "char": "🤚",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "muscle": {
          "keywords": ["arm", "flex", "hand", "summer", "strong", "biceps"],
          "char": "💪",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "handshake": {
          "keywords": ["agreement", "shake"],
          "char": "🤝",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "point_left": {
          "keywords": ["direction", "fingers", "hand", "left"],
          "char": "👈",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "point_right": {
          "keywords": ["fingers", "hand", "direction", "right"],
          "char": "👉",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "fu": {
          "keywords": ["hand", "fingers", "rude", "middle", "flipping"],
          "char": "🖕",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "raised_hand_with_fingers_splayed": {
          "keywords": ["hand", "fingers", "palm"],
          "char": "🖐",
          "fitzpatrick_scale": true,
          "category": "people"
        },
        "lips": {
          "keywords": ["mouth", "kiss"],
          "char": "👄",
          "fitzpatrick_scale": false,
          "category": "people"
        },
        "ear": {
          "keywords": ["face", "hear", "sound", "listen"],
          "char": "👂",
          "fitzpatrick_scale": true,
          "category": "people"
        },

        "eyes": {
          "keywords": ["look", "watch", "stalk", "peek", "see"],
          "char": "👀",
          "fitzpatrick_scale": false,
          "category": "people"
        },

        "santa": {
          "keywords": ["festival", "man", "male", "xmas", "father christmas"],
          "char": "🎅",
          "fitzpatrick_scale": true,
          "category": "people"
        },

        "sun_with_face": {
          "keywords": ["nature", "morning", "sky"],
          "char": "🌞",
          "fitzpatrick_scale": false,
          "category": "animals_and_nature"
        },
        "crescent_moon": {
          "keywords": ["night", "sleep", "sky", "evening", "magic"],
          "char": "🌙",
          "fitzpatrick_scale": false,
          "category": "animals_and_nature"
        },
        "star": {
          "keywords": ["night", "yellow"],
          "char": "⭐",
          "fitzpatrick_scale": false,
          "category": "animals_and_nature"
        },

        "zap": {
          "keywords": ["thunder", "weather", "lightning bolt", "fast"],
          "char": "⚡",
          "fitzpatrick_scale": false,
          "category": "animals_and_nature"
        },
        "fire": {
          "keywords": ["hot", "cook", "flame"],
          "char": "🔥",
          "fitzpatrick_scale": false,
          "category": "animals_and_nature"
        },

        "snowflake": {
          "keywords": ["winter", "season", "cold", "weather", "christmas", "xmas"],
          "char": "❄️",
          "fitzpatrick_scale": false,
          "category": "animals_and_nature"
        },

        "soccer": {
          "keywords": ["sports", "football"],
          "char": "⚽",
          "fitzpatrick_scale": false,
          "category": "activity"
        },
        "basketball": {
          "keywords": ["sports", "balls", "NBA"],
          "char": "🏀",
          "fitzpatrick_scale": false,
          "category": "activity"
        },
        "football": {
          "keywords": ["sports", "balls", "NFL"],
          "char": "🏈",
          "fitzpatrick_scale": false,
          "category": "activity"
        },
        "baseball": {
          "keywords": ["sports", "balls"],
          "char": "⚾",
          "fitzpatrick_scale": false,
          "category": "activity"
        },
        "gift": {
          "keywords": ["present", "birthday", "christmas", "xmas"],
          "char": "🎁",
          "fitzpatrick_scale": false,
          "category": "objects"
        },

        "tada": {
          "keywords": ["party", "congratulations", "birthday", "magic", "circus", "celebration"],
          "char": "🎉",
          "fitzpatrick_scale": false,
          "category": "objects"
        },

        "black_nib": {
          "keywords": ["pen", "stationery", "writing", "write"],
          "char": "✒️",
          "fitzpatrick_scale": false,
          "category": "objects"
        },
        "memo": {
          "keywords": ["write", "documents", "stationery", "pencil", "paper", "writing", "legal", "exam", "quiz", "test", "study", "compose"],
          "char": "📝",
          "fitzpatrick_scale": false,
          "category": "objects"
        },
        "heart": {
          "keywords": ["love", "like", "valentines"],
          "char": "❤️",
          "fitzpatrick_scale": false,
          "category": "symbols"
        },
        "yellow_heart": {
          "keywords": ["love", "like", "affection", "valentines"],
          "char": "💛",
          "fitzpatrick_scale": false,
          "category": "symbols"
        },
        "green_heart": {
          "keywords": ["love", "like", "affection", "valentines"],
          "char": "💚",
          "fitzpatrick_scale": false,
          "category": "symbols"
        },
        "vs": {
          "keywords": ["words", "orange-square"],
          "char": "🆚",
          "fitzpatrick_scale": false,
          "category": "symbols"
        },
        "speech_balloon": {
          "keywords": ["bubble", "words", "message", "talk", "chatting"],
          "char": "💬",
          "fitzpatrick_scale": false,
          "category": "symbols"
        },

        "clock1": {
          "keywords": ["time", "late", "early", "schedule"],
          "char": "🕐",
          "fitzpatrick_scale": false,
          "category": "symbols"
        }
      },
      isZj: false,
      mask: false,
      mask2: false,
      prompt: false,
      hint: '',
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      noCount: '',
      mipQuestionAnswer: {},
      labelList: [],
      labelTypeList: [],
      showStatus: this.$route.query.docAudit,
      yesCount: 0,
      list: [],
      chatQuestion: {},
      chatDoctor: {},
      mipBaiduQuestion: {},
      content: '',
      replyStatus: 1,
      noReplyReason: '',
      mipDoctor: {},
      userId: '',
      doctorId: '',
      questionId: '',

      showImg: false,
      imgSrc: '',
      flag: true,

      boxStatus: false,
      emojiStatus: false,
      baiduCommonPhraseList: [],
      tt: '',
      moreStatus: false,


      bespeakId: '',
      infoData: {},
      pageIndex: 1,
      pageSize: 25,
      count: 0,
      noMoreData: false,
      isLoading: false,
      beforeScrollHeight: 0,
      afterScrollHeight: 0,
      bespeakSwitch: {},
      fileNameList: null,
      fileList: null,
    }
  },
  components: {
    topbar,
    noMoreData,
    bigImg,
  },
  updated() {
    // 聊天定位到底部
    let ele = document.getElementById('box');
    ele.scrollTop = ele.scrollHeight;
  },
  watch: {
    '$route'(to, from) {
      this.$router.go(0)
    },
    list() {
      if (this.list.length <= this.pageSize) {
        this.onScrollBottom();
      } else {
        this.nofresh()
      }
    },
    '$store.state.info': function (value) {
      console.log(value)
      if (value == this.bespeakId) {
        this.list = [];
        this.pageIndex = 1;
        this.getBespeakChatDetailForDoctorDialogue()
      }

    }

  },
  filters: {
    time(value) {
      let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
      return transTime
    },

    isPatientSex(tag) {
      let arr = ['男', '女'];
      return arr[tag]
    },
    isUrl(value) {
      var url = value;
      var urlReg = /(http:\/\/|ftp:\/\/|https:\/\/|www.)[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/g;
      var array = url.match(urlReg);
      console.log(array)
      // 设置!!为临时占位符
      var rpStr = url.replace(urlReg, '!!')
      console.log(rpStr)

      function insertLink(el, i, arr) {
        //匹配协议，因为Vuejs会对href属性自动加上' http:// '
        if (el.match('http://') || el.match('ftp://') || el.match('https://')) {
          // console.log('yes')
          var link = ('<a href=\"' + el + '\">' + el + '</a>');
        } else {
          // console.log('false')
          var link = ('<a href=\"http:\/\/' + el + '\">' + el + '</a>');
        }
        // console.log(rpStr)
        // console.log(links)
        // 将字符串里的!! 替换为link的内容并重新赋值给 rpStr
        rpStr = rpStr.replace('!!', link)
        console.log('result', rpStr)
        return rpStr
      }

      if (array) {
        array.forEach(insertLink);
      }

      console.log(rpStr)
      return rpStr
    },
  },

  methods: {
    isServeType(v) {
      let arr = ['图文咨询', '电话咨询', '视频咨询', '线下咨询']
      return arr[v]
    },
    cancle() {
      this.connType = '';
      this.startContent = '';
      this.maskStatus = false
    },
    selectFileEvent(fileNameList) {
      // 清空文件名列表和文件
      var fileNameList = "";
      let formDate = this.$refs.file.files;
      for (let i = 0; i < formDate.length; i++) {
        if (formDate[i].name != null || formDate[i].name != "") {
          if (formDate[i].name.length > 20) {
            let name = formDate[i].name.split(".");
            // console.log(name,'name')
            fileNameList =
              fileNameList +
              `${name[0].substr(0, 16)}... .${name[name.length - 1]}` +
              ";";
          } else {
            fileNameList = fileNameList + formDate[i].name + ";";
          }
        }
      }
      this.fileNameList = fileNameList;
      this.fileList = formDate;

      //上传图片
      this.getToken(this.fileList[0], this.fileNameList)
    },
    async getToken(dataurl, filename) {
      var that = this;
      var xhr = new XMLHttpRequest();
      xhr.open('post', '/bear-scale/api/qiniu/obtainPictureUploadToken.json');
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
//发送请求
      xhr.send('');
      xhr.onreadystatechange = function () {
        console.log(xhr)
        // 这步为判断服务器是否正确响应
        if (xhr.readyState == 4) {
          let data = JSON.parse(xhr.responseText)

          that.putb64(dataurl, dataurl.name, data.token)
        }
      };
    },
    async putb64(pic, filename, token) {
      var _this = this
      const observable = qiniu.upload(pic, filename, token)
      var observer = {
        next(res) {
        },
        error(err) {
          console.log(err)
        },
        complete(res) {
          console.log('upload remote url:', res.key)

          let paramsObj = {}
          paramsObj.content = "https://cdn.ysqingxin.com/" + res.key;
          paramsObj.contentType = 1;
          paramsObj.doctorId = localStorage.getItem('doctorId');
          paramsObj.bespeakId = _this.bespeakId;
          _this.replyBespeakChat(paramsObj)
        }
      };
      // 上传开始
      var subscription = observable.subscribe(observer);
    },
    openPhoto() {
      this.$refs.file.click();
    },
    openMask(n) {
      if (n === 0 || n === 1) {
        this.startContent = `用户预约的是<span style="color:#00C59F;">${moment(this.infoData.bespeakDate).format('YYYY-MM-DD HH:mm:ss')}</span>的${this.isServeType(this.infoData.serveType)}。请在此时间点双方登录系统后发起会话！若咨询时间有变动，请双方沟通后约定时间点再次发起会话。`

      } else {
        this.startContent = `用户预约的是<span style="color:#00C59F;">${moment(this.infoData.bespeakDate).format('YYYY-MM-DD HH:mm:ss')}</span>的${this.isServeType(this.infoData.serveType)}。您确定要进行拨号吗？`

      }
      this.connType = n
      this.maskStatus = true
    },
    sureStart() {
      if (this.connType === 0 || this.connType === 1) {
        this.requestRealTimeConn(this.connType)
      } else {
        this.startPhoneCall()
      }
    },
    showTip(v) {
      this.tip = v;
      this.tipStatus = true;
      setTimeout(() => {
        this.tipStatus = false;
      }, 2000)
    },
    isUrl(value) {
      var url = value;
      var urlReg = /(http:\/\/|ftp:\/\/|https:\/\/|www.)[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/g;
      var array = url.match(urlReg);
      // 设置!!为临时占位符
      var rpStr = url.replace(urlReg, '!!')

      function insertLink(el, i, arr) {
        //匹配协议，因为Vuejs会对href属性自动加上' http:// '
        if (el.match('http://') || el.match('ftp://') || el.match('https://')) {
          // console.log('yes')
          var link = ('<a style="color: #0A89CB" target="_blank" href=\"' + el + '\">' + el + '</a>');
        } else {
          // console.log('false')
          var link = ('<a style="color: #0A89CB" target="_blank" href=\"http:\/\/' + el + '\">' + el + '</a>');
        }
        // console.log(rpStr)
        // console.log(links)
        // 将字符串里的!! 替换为link的内容并重新赋值给 rpStr
        rpStr = rpStr.replace('!!', link)
//                    console.log('result',rpStr)
        return rpStr
      }

      if (array) {
        array.forEach(insertLink);
      }
      return rpStr
    },
    showMore() {
      this.boxStatus = false;
      this.emojiStatus = false;

      this.moreStatus = !this.moreStatus;
    },
    changeInput(value) {
      this.content = '1'
    },
    to(n) {
      this.$router.push(`/${n}`)
    },
    back() {
      history.back()
    },
    emojiSected(emoji) {
//                const dom = this.$refs.demo.innerHTML + `<img src="${base64}" />`;
//                this.$refs.demo.innerHTML = dom;
      console.log(emoji)
      let v = document.querySelectorAll('#sendInput')[0].innerHTML;
      document.querySelectorAll('#sendInput')[0].innerHTML = v + emoji;
      this.content = this.content + emoji;
    },

    getFocus() {
      this.closeAll();
    },
    toWord(content) {
      let v = document.querySelectorAll('#sendInput')[0];
      v.innerHTML = '';
      v.innerHTML = content;
      this.changeUnrealHits();
    },
    closeAll() {
      this.boxStatus = false;
      this.emojiStatus = false;
      this.moreStatus = false;
    },
    showBox() {
      this.closeAll();
      this.boxStatus = true;
    },
    showEmoji() {
      if (this.replyStatus) {
        this.closeAll();
        this.emojiStatus = true;
      }

    },
    changeUnrealHits() {
      let v = document.querySelectorAll('#sendInput')[0].innerHTML;
      console.log(v)
      v = v.replace(/(^\s*)/g, "");
      v = v.replace(/<[^>]*>/g, "");
      v = v.replace(/%/g, '%25')
      v = v.replace(/&nbsp;/ig, '')
      console.log(v)
      this.content = v;
    },
    onScrollBottom() {
      console.log(1111111111111111111111)
      this.$nextTick(() => {
        const container = this.$el.querySelector('#box')
        document.documentElement.scrollTop = container.scrollHeight
        document.body.scrollTop = container.scrollHeight
        this.beforeScrollHeight = container.scrollHeight
      })
    },
    nofresh() {
      this.$nextTick(() => {
        // console.log(this.$el.querySelector('#box').scrollHeight)
        // console.log(this.beforeScrollHeight)
        this.afterScrollHeight = this.$el.querySelector('#box').scrollHeight - this.beforeScrollHeight;
        this.beforeScrollHeight = this.$el.querySelector('#box').scrollHeight;
        document.documentElement.scrollTop = this.afterScrollHeight
        document.body.scrollTop = this.afterScrollHeight
      })
    },
    getCookie(key) {
      let cookieStr = document.cookie.split("; ");
      for (let i = 0; i < cookieStr.length; i++) {
        let tempArr = cookieStr[i].split("=");
        if (tempArr[0] == key) {
          return tempArr[1];
        }
      }
      return null;
    },
    muiscPlay(id) {
      let gamemuiscs1 = new Audio(id);
      gamemuiscs1.play();
    },
//        点击放大图片
    clickImg(e) {
      this.showImg = true;
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src;
    },
    viewImg() {
      this.showImg = false;
    },
    submit() {
      let paramsObj = {}
      paramsObj.content = this.content;
      paramsObj.contentType = 0;
      paramsObj.doctorId = localStorage.getItem('doctorId');
      paramsObj.bespeakId = this.bespeakId;
      // paramsObj.chatType = 0;
      // if (this.flag) {
      //     if(this.chatQuestion){
      //         paramsObj.questionId = this.chatQuestion.questionId;
      this.replyBespeakChat(paramsObj)
      //     }else{
      //         this.sendQuestion()
      //     }
      // }

    },
    async replyBespeakChat(params) {
      this.flag = false;
      let data = await getSources("/bear-scale/api/scaleUserBespeakChat/replyBespeakChat.json", params);
      if (data.status === 0) {
        this.content = '';
        document.querySelectorAll('#sendInput')[0].innerHTML = '';
        this.pageIndex = 1;
        this.list = [];
        this.getBespeakChatDetailForDoctorDialogue()
        setTimeout(() => {
          this.flag = true;
        }, 200)

      } else {
        this.flag = true;
        alert(`${data.msg}`)
      }
    },
    jump(type) {
      window.open(`https://m.120xinmao.com/agora/#/?doctorId=${this.infoData.doctorId}&userId=${this.infoData.userId}&type=${type}`, '_blank')
    },
    async getBespeakSwitchForDoctor() {
      let data = await getSources("/bear-scale/api/scaleUserBespeakSwitch/getBespeakSwitchForDoctor.json", {
        bespeakId: this.bespeakId,
        doctorId: localStorage.getItem('doctorId')
      });
      if (data.status === 0) {
        this.bespeakSwitch = data.bespeakSwitch
        this.infoData = data
        this.replyStatus = data.replyStatus;
        this.noReplyReason = data.NoReplyMsg;
      } else {
        alert(`${data.msg}`)
      }
    },
    async requestRealTimeConn(n) {
      this.flag = false;
      let data = await getSources("/bear-scale/api/scaleUserBespeakChat/requestRealTimeConn.json", {
        connType: n,
        bespeakId: this.bespeakId,
        doctorId: localStorage.getItem('doctorId')
      });
      if (data.status === 0) {
        this.pageIndex = 1;
        this.list = [];
        this.getBespeakChatDetailForDoctorDialogue()
        this.cancle();
        setTimeout(() => {
          this.flag = true;
        }, 200)
      } else {
        alert(`${data.msg}`)
      }
    },
    async startPhoneCall() {
      let data = await getSources("/bear-scale/api/scaleUserBespeakSwitch/startPhoneCall.json", {
        bespeakId: this.bespeakId,
        doctorId: localStorage.getItem('doctorId')
      });
      if (data.status === 0) {
        if (data.bespeakSwitchPhone) {
          this.cancle();
          setTimeout(() => {
            this.showTip(`请注意接听来电~`)
          }, 200)

        } else {
          window.location.href = 'tel://' + data.middleNumber
        }

      } else {
        alert(`${data.msg}`)
      }
    },
    async getBespeakChatDetailForDoctorDialogue(id) {
      let paramsObj = {}
      paramsObj.bespeakId = this.bespeakId
      paramsObj.doctorId = localStorage.getItem('doctorId')
      paramsObj.pageSize = this.pageSize;
      paramsObj.pageIndex = this.pageIndex;
//                let data = await getSources("/depression-mip/mip/baiDuQuestion/getBaiduQuestionDetail.json", this.serialize(paramsObj));
      let data = await getSources("/bear-scale/api/scaleUserBespeakChat/getBespeakChatDetailForDoctorDialogue.json", paramsObj);

      if (!this.list.length || data.userBespeakChatDialogueList.length !== this.list.length) {
        if (data.status == 0) {
          this.$store.commit('setInfo', '')
          this.isLoading = false;
          this.count = data.count;
          let arr = data.userBespeakChatDialogueList.reverse()
          arr.forEach(item => {
            if (item.contentType == 4) {
              item.content = JSON.parse(item.content)
            }
          })
          //this.list = [ ...arr, ...this.list];
          this.list = this.list.concat(arr.slice(this.list.length, arr.length));
          if (data.userBespeakChatDialogueList.length === 0) {
            this.noMoreData = true
          } else {
            if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
              this.noMoreData = true
            } else {
              this.noMoreData = false
            }
          }

          //this.$previewRefresh()

        } else {
          alert(`${data.msg}`);
        }
      }

    },
    handleScroll() {
      if (this.flag) {
        let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
        // let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
        let bottomOfWindow = scrolltop <= 20
        if (bottomOfWindow && this.isLoading == false) {

          if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
            this.noMoreData = true
          } else {
            this.isLoading = true;
            this.pageIndex = this.pageIndex + 1;
            this.getBespeakChatDetailForDoctorDialogue()
          }
        }
      }


    },

  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    clearInterval(this.intv)
  },
  mounted() {
    this.bespeakId = this.$route.query.bespeakId;
    this.getBespeakSwitchForDoctor();
    this.getBespeakChatDetailForDoctorDialogue();
    window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件


    this.intv = setInterval(() => {
      this.getBespeakChatDetailForDoctorDialogue()
    }, 3000)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reply.vue